import React from "react";
import styled from "styled-components";
import { CSVLink } from "react-csv";
import { BreakpointDisplay } from "./breakpointDisplay";
import { ExportAsExcelSvg } from "../icons";

const ExportButtons = ({ csvData, csvFileName }) => (
  <div className="flex mr-3">
    <BreakpointDisplay breakpoint={768}>
      <div className={`flex items-center ${csvData?.length < 2 ? "cursor-not-allowed opacity-60" : ""}`}>
        <BreakpointDisplay breakpoint={1024}>
          <ViewText>
            Export:
          </ViewText>
        </BreakpointDisplay>
        <div className="flex ml-2.5">
          {/* <ExportAsOtherSvg />
          <div className="mx-3">
            <PipeSvg />
          </div> */}
          <CSVLink
            filename={csvFileName}
            data={csvData}
            onClick={(e) => {
              if (csvData?.length < 2) {
                e.preventDefault();
              }
            }}
          >
            <ExportAsExcelSvg />
          </CSVLink>
        </div>
      </div>
    </BreakpointDisplay>
  </div>
);

const ViewText = styled.div`
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
  color: ${window?.settings?.secondary_color ?? '#04333b'};
`;

export default ExportButtons;
